import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import Axios from "axios";
import Notifications from "vue-notification";
import VSelect from "vue-select";
import "./directives/outsideClickHandler";
import router from "./router";
import store from "./store/index";
import App from "./App.vue";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import VueCurrencyInput from "vue-currency-input";
import VueNumeric from "vue-numeric";
import VueMask from "v-mask";
import VueTheMask from "vue-the-mask";
import * as VueGoogleMaps from "vue2-google-maps"
import JsonCSV from 'vue-json-csv'
Vue.use(VueTheMask);

const pluginOptions = {
  globalOptions: { currency: "BRL" }
};
Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VueNumeric);
Vue.use(VueMask);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBdCF7IwBMCvFSWGANRHDtQxnlfiD9iUAA",
    libraries: "places" // necessary for places input
  }
});

var axiosInstance = Axios.create({
  baseURL: store.getters.baseURL
});

// declare a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosInstance;
const local = JSON.parse(localStorage.getItem("user-token"));

if (local) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "bearer " + local.token;
}

Vue.use(CoreuiVue);
Vue.use(BootstrapVue);

Vue.use(Notifications);
Vue.component("v-select", VSelect);
Vue.use(HighchartsVue);
Vue.use(Highcharts);
Vue.component('downloadCsv', JsonCSV)

Vue.directive('permission', {
  inserted(el, binding, vnode) {
    if (
      store.getters.getAutenticacao.permissoes.filter(
        (x) => x === binding.value
      ).length <= 0) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})

Vue.config.productionTip = false;

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next("/login");
      return;
    }
    if (
      to.meta.permission &&
      store.getters.getAutenticacao.permissoes.filter(
        (x) => x === to.meta.permission
      ).length <= 0
    ) {
      next("/sem-permissao");
      return;
    }
    if (to.meta.requiresPmau) {
      if (store.state.main.pmauHabilitado === null) {
        await store.dispatch("fetchPmauAccess");
      }
      if (!store.state.main.pmauHabilitado) {
        next("/dashboard");
        return;
      }
    }
    if (to.meta.requiresPmauAdmin) {
      if (store.state.main.pmauAdmin === null) {
        await store.dispatch("fetchPmauAdmin");
      }
      if (!store.state.main.pmauAdmin) {
        next("/dashboard");
        return;
      }
    }
    next();
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  icons,
  render: (h) => h(App)
}).$mount("#app");
